<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <div>

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-user" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-1 font-weight-bold">{{ dependent.full_name || 'Dependent Profile' }}</h4>
              <div class="d-flex align-items-center" style="gap: 8px;">
                <span v-if="dependent.status == 'active'" class="header-status header-status--active">
                  <i class="fe fe-check-circle mr-1"></i> Active
                </span>
                <span v-else class="header-status header-status--inactive">
                  <i class="fe fe-alert-circle mr-1"></i> Inactive
                </span>
                <span class="header-id-badge" v-if="dependent.id_card_number">
                  {{ dependent.id_card_number }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">
        <div class="row">
          <div class="col-lg-12">

            <!-- Profile Card -->
            <div class="card table-card shadow mb-4">
              <div class="form-card-header">
                <div class="section-number"><i class="fe fe-user" style="font-size:13px;"></i></div>
                <div>
                  <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Dependent Profile</p>
                  <small style="color:rgba(255,255,255,.7);">Personal and coverage details</small>
                </div>
              </div>
              <div class="card-body row">

                <!-- Photo Column -->
                <div class="col-md-3 text-center border-right pt-3 pb-3">
                  <vue-initials-img
                    :name="dependent.firstname + ' ' + dependent.lastname"
                    class="rounded-circle mx-auto mb-3"
                    style="width:100px;height:100px;"
                    v-if="dependent.image == null"
                  />
                  <div v-if="dependent.image != null" class="mb-3">
                    <img
                      :src="`${dependent.image_url}`"
                      class="rounded-circle mx-auto d-block"
                      style="width:100px;height:100px;object-fit:cover;"
                    />
                  </div>
                  <p class="font-weight-bold mb-0">{{ dependent.firstname }} {{ dependent.lastname }}</p>
                  <small class="text-muted">Dependent</small>
                  <div class="mt-2" v-if="dependent.status == 'active'">
                    <span class="badge badge-soft-success px-3 py-1" style="border-radius:20px;font-size:.75rem;">
                      <i class="fe fe-check-circle mr-1"></i> Active
                    </span>
                  </div>
                  <div class="mt-2" v-else>
                    <span class="badge badge-soft-warning px-3 py-1" style="border-radius:20px;font-size:.75rem;">
                      <i class="fe fe-alert-circle mr-1"></i> Inactive
                    </span>
                  </div>
                </div>

                <!-- Info Column -->
                <div class="col-md-9 p-0">
                  <ul class="list-unstyled mb-0">
                    <li class="info-row">
                      <i class="fe fe-user info-icon"></i>
                      <div>
                        <p class="info-label">Name</p>
                        <p class="info-value">{{ dependent.firstname }} {{ dependent.lastname }}</p>
                      </div>
                    </li>
                    <li class="info-row">
                      <i class="fe fe-credit-card info-icon"></i>
                      <div>
                        <p class="info-label">Enrollee ID</p>
                        <p class="info-value"><span class="code-chip">{{ dependent.id_card_number }}</span></p>
                      </div>
                    </li>
                    <li class="info-row">
                      <i class="fe fe-users info-icon"></i>
                      <div>
                        <p class="info-label">Principal</p>
                        <p class="info-value">
                          {{ dependent.user && dependent.user.full_name }}
                          <span class="code-chip ml-1" v-if="dependent.user">{{ dependent.user.id_card_number }}</span>
                        </p>
                      </div>
                    </li>
                    <li class="info-row">
                      <i class="fe fe-phone info-icon"></i>
                      <div>
                        <p class="info-label">Phone Number</p>
                        <p class="info-value">{{ dependent.phone_number }}</p>
                      </div>
                    </li>
                    <li class="info-row" v-if="dependent.localgovt">
                      <i class="fe fe-map-pin info-icon"></i>
                      <div>
                        <p class="info-label">LGA</p>
                        <p class="info-value">{{ dependent.localgovt.local_name }}</p>
                      </div>
                    </li>
                    <li class="info-row">
                      <i class="fe fe-gift info-icon"></i>
                      <div>
                        <p class="info-label">Date of Birth</p>
                        <p class="info-value">{{ dependent.dob | moment("dddd, MMMM Do YYYY") }}</p>
                      </div>
                    </li>
                    <li class="info-row">
                      <i class="fe fe-user info-icon"></i>
                      <div>
                        <p class="info-label">Gender</p>
                        <p class="info-value">{{ dependent.gender }}</p>
                      </div>
                    </li>
                    <li class="info-row">
                      <i class="fe fe-link info-icon"></i>
                      <div>
                        <p class="info-label">Relationship Type</p>
                        <p class="info-value">{{ dependent.relationShipType }}</p>
                      </div>
                    </li>
                    <li class="info-row">
                      <i class="fe fe-hash info-icon"></i>
                      <div>
                        <p class="info-label">NIN</p>
                        <p class="info-value">{{ dependent.nimc_number }}</p>
                      </div>
                    </li>
                    <li class="info-row">
                      <i class="fe fe-calendar info-icon"></i>
                      <div>
                        <p class="info-label">Expiry Date</p>
                        <p class="info-value">{{ dependent.expiry_date | moment("dddd, MMMM Do YYYY") }}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Activities Card -->
            <div class="card table-card shadow mb-4" v-if="activities && activities.data">
              <div class="d-flex align-items-center px-4 pt-4 pb-3">
                <i class="fe fe-activity text-primary mr-2"></i>
                <h6 class="mb-0 font-weight-bold">Activities</h6>
              </div>
              <div class="card-body pt-0">
                <div v-if="activities.data.length">
                  <div v-for="activity in activities.data" :key="activity.id" class="media mb-3">
                    <div class="employee-avatar mr-3" style="width:36px;height:36px;flex-shrink:0;">
                      {{ activity.causer && activity.causer.full_name ? activity.causer.full_name.charAt(0) : '?' }}
                    </div>
                    <div class="media-body">
                      <p class="mb-0 font-weight-bold" style="font-size:.85rem;">{{ activity.causer && activity.causer.full_name }}</p>
                      <span class="badge badge-soft-info">{{ activity.description }}</span>
                      <small class="text-muted d-block mt-1">{{ activity.created_at | moment("from", "now") }}</small>
                    </div>
                  </div>
                </div>
                <p v-else class="text-muted text-center py-3" style="font-size:.85rem;">
                  <i class="fe fe-inbox mr-1"></i> No activities recorded
                </p>
              </div>
            </div>

          </div>
        </div>

        <!-- Webcam Modal -->
        <div class="modal fade" id="example_01" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="container-fluid">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="row">
                  <div class="col-md-12 p-t-20 p-b-20">
                    <video id="video" width="100%" height="auto" autoplay></video>
                    <p>
                      <button @click="takePic" class="bg-navy btn btn-flat">Snap Photo</button>
                      <button type="button" class="btn btn-info" @click="savePic">Save pic</button>
                    </p>
                    <canvas id="canvas" width="720px" height="550px"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </div>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
// import { WebCam } from "vue-web-cam";

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      dependent: "",
      notes: "",
      medications: "",
      image: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      agency_id: "",
      imagefile: "",
      activities: "",
      pictureShower: true,
    };
  },
  mounted() {
    //
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/getSpeicifDependant/${this.$route.params.id}`)
      .then((response) => {
        this.dependent = response.data.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  methods: {
    attachPic(event) {
      this.user = JSON.parse(localStorage.getItem("user"));

      console.log(event);
      // let files = event.target.files
      // let filename = event.target.files[0].name
      this.image = event.target.files[0];
      this.uploadPic();
    },
    uploadPic() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));

      var formData = new FormData();
      formData.append("user_image", this.image);
      formData.append("dependant_id", this.$route.params.id);
      this.axios
        .post(
          "/api/v1/auth/uploadDependantImage",
          // {user_image: this.image, dependant_id: this.$route.params.id}
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$breadstick.notify("Profile Image changed Successfully!", {
            position: "top-right",
          });
          this.fetchUser();
        });
    },
    takePic() {
      var video = document.getElementById("video");
      var canvas = document.getElementById("canvas");
      var context = canvas.getContext("2d");

      context.drawImage(video, 0, 0, 640, 480);

      // get image
      var image = new Image();
      image.src = canvas.toDataURL("image/png");
      console.log(image);
      localStorage.setItem("snap", this.imagefile.src);
      this.imagefile = image.src;

      // upload image

      // end of upload image
    },

    savePic() {
      this.axios
        .post(`/api/v1/auth/uploadcustomerpicImage`, {
          user_image: this.imagefile,
          user_id: this.$route.params.id,
        })
        .then((response) => {
          console.log(response);
          this.$breadstick.notify("Profile Image changed Successfully!", {
            position: "top-right",
          });
          this.fetchUser();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchUser() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getSpeicifDependant/${this.$route.params.id}`)
        .then((response) => {
          this.dependent = response.data.data;
           this.activities = response.data.activities;

          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    uploadPicSnapped() {
      this.isLoading = true;
      let snap = localStorage.getItem("snap");

      var formData = new FormData();
      formData.append("user_image", snap);
      this.axios
        .post("/api/v1/auth/uploadUserImage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$breadstick.notify("Profile Image changed Successfully!", {
            position: "top-right",
          });
          // this.getUser()
        });
    },
  },
  created() {
    this.fetchUser();
  },
};
</script>
